import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';
import TitledTextField from '../../core/TitledTextField';
import withGS from '../../core/withGShoc';
import { MAX_LABEL_LENGTH } from '../constants';
import { getAllLabelValues } from '../../core/utils/utils';

class SuggestionAltLabelField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            acOpen: false,
            isDuplicate: false,
            suggestedLabel: ""
        };
    }

    handleChange = event => {
        const t = event.target;
        this.setState({ [t.name]: t.value.trimLeft() });
        if (t.value.trimLeft() !== "") {
            const data = this.props.data;
            const lang = this.props.lang;
            const allLabels = getAllLabelValues(data, lang);
            const isDuplicate = allLabels.some(al => al.toLowerCase() === t.value.trimLeft().toLowerCase());
            this.setState({ isDuplicate, suggestedLabel: t.value.trimLeft() });
            this.props.isValid(t.value.trim(), isDuplicate);
        }
        else {
            this.setState({ isDuplicate: false, suggestedLabel: "" });
            this.props.isValid("", false);
        }
    };

    render() {

        const { lang } = this.props;
        const { suggestedLabel, isDuplicate } = this.state;

        return (
            <React.Fragment>
                <TitledTextField
                    dataTest="language-value"
                    name="suggestedLabel"
                    title={"Label"}
                    required={true}
                    text={suggestedLabel}
                    placeholder={"Enter suggested label"}
                    margin={true}
                    maxLength={MAX_LABEL_LENGTH}
                    lang={lang}
                    error={isDuplicate}
                    errorText={isDuplicate ?
                        "This value already exists on this concept."
                        :
                        null
                    }
                    onChange={this.handleChange} />
            </React.Fragment>
        );
    }
}

SuggestionAltLabelField.propTypes = {
    graph: PropTypes.string.isRequired,
    isValid: PropTypes.func.isRequired,
    schemeIRI: PropTypes.string,
    optionForXL: PropTypes.bool.isRequired,
    existingValues: PropTypes.object,
    name: PropTypes.string,
    lang: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(SuggestionAltLabelField, ["ALL"], null, {}));